import * as myTreeIcons from "../images/icons/treeicons";
import { dbItem, kamerItem } from "../Shared/sharedInterfaces"; //../.sharedInterfaces";
import Icon from "@mui/material/Icon";
import { WoningIcon } from "../images/icons/svgIcons";
import {getTranslations} from "../Shared/translations";

export const ChangeTreeItemIcon = (
  itemId: string,
  icon: string,
  woningTree: any,
  woningDb: any
) => {
  // Update name in woningObject (for tree)
  let woningObject = woningTree;
  const loopWoning = (nodes: kamerItem) =>
    nodes.children?.map((item) => {
      if (item.id === itemId) {
        item.icon = myTreeIcons.getTreeIcon2(icon, icon);
      }
      if (item.children) {
        loopWoning(item);
      }
    });

  loopWoning(woningObject);

  // Update name in woningDb (for project)
  let found2: dbItem = woningDb.find(
    (element: dbItem) => element.nodeid === itemId
  )!;
  if (found2 !== undefined) {
    found2.typeIcon = icon;
    found2.type = icon;
  }

  //debugger
  return woningObject;
};

export const RemoveTreeItem = (
  itemId: string,
  woningTree: any,
  woningDb: dbItem[]
) => {
  let woningObject = woningTree;
  // First step remove items from woning
  const loopWoning = (kamerItem: kamerItem) =>
    kamerItem.children?.map((item) => {
      var newwoningObject: any;
      // if item has children (item = kamer) then check if item to remove is in children, if so remove childitem
      if (item.children) {
        //set newwoningObject =
        newwoningObject = item.children.filter(function (el: kamerItem) {
          //console.log("A ", el) // only elements in rooms
          return el.id != itemId;
        });
        item.children = newwoningObject;
        loopWoning(item);
      }
    });

  loopWoning(woningObject);

  // onderstaande verwijderd enkel uit woning
  var newwoningObject: any = woningTree.children.filter(function (
    el: kamerItem
  ) {
    return el.id != itemId;
  });

  woningObject.children = newwoningObject;

  return woningObject;
};

export const removeItemFromDb = (itemId: string, woningDb: dbItem[]) => {
  /*
  // store db in temp
  let tempWoningDb = woningDb;

  // Find db item with specified id
  var itemToRemove = tempWoningDb.filter(function (el: any) {
    return el.nodeid === itemId;
  });

  let newa: dbItem[] = [];
  // if item is a room - remove all children
  if (itemToRemove[0].type === "woning") {
    // loop items and push items with diferent parent then our parent to remove to newa
    tempWoningDb.map((element: any) => {
      if (element.parent !== itemToRemove[0].nodeid) {
        newa.push(element);
      }
    });
  } else {
    newa = tempWoningDb;
  }

  // remove item
  itemToRemove.forEach((f: any) =>
    newa.splice(
      newa.findIndex((e: any) => e.nodeid === f.nodeid),
      1
    )
  );
*/
  const updatedItems = woningDb.filter((item) => item.nodeid !== itemId);

  return updatedItems;
};

// Changes the name of an item (in woningtree and db)
export const ChangeTreeItemName = (
  itemId: string,
  newName: string,
  woningTree: any,
  woningDb: dbItem[]
) => {
  // Update name in woningTree

  const loopWoning = (nodes: kamerItem) =>
    nodes.children?.map((item) => {
      if (item.id === itemId) {
        item.name = newName;
      }
      if (item.children) {
        loopWoning(item);
      }
    });

  loopWoning(woningTree);

  // Update woningDb (for)
  let found2: dbItem = woningDb.find(
    (element: dbItem) => element.nodeid === itemId
  )!;
  if (found2 !== undefined) {
    found2.label = newName;
  }

  return woningTree;
};

// Utility to get saved state from localStorage
const getPersistedExpanded = (): string[] => {
  const stored = localStorage.getItem("expandedTreeNodes");
  return stored ? JSON.parse(stored) : [];
};

const addIfNotExists = (arr: string[], item: string): string[] => {
  return arr.includes(item) ? arr : [...arr, item];
};

// Utility to save to localStorage
const addExpanded = (expanded: string) => {
  const currExp = getPersistedExpanded();
  if (currExp) {
    const updatedExpanded = addIfNotExists(currExp, expanded);
    const sortedDesc = updatedExpanded.sort((a, b) => Number(b) - Number(a));
    localStorage.setItem("expandedTreeNodes", JSON.stringify(sortedDesc));
  }
};

const getChildrenCount = (): number => {
  let aantal = 0;
  return 0;
};

// We need this function to sort our woning array
// If we move an item to a higher parent, then we need that parent higher is te list
const sortByDependencyAndNodeId = (data: dbItem[]) => {
  const nodes = data.filter((obj) => Object.keys(obj).length > 0);

  const map = new Map();
  nodes.forEach((node) => {
    map.set(node.nodeid, node);
  });

  const visited = new Set();
  const inProgress = new Set(); // ← tracks current DFS path
  const sorted: dbItem[] = [];

  function visit(nodeId: string) {
    if (visited.has(nodeId)) return;
    if (inProgress.has(nodeId)) {
      console.warn(`Circular dependency detected at node: ${nodeId}`);
      return; // ← break the cycle
    }

    const node = map.get(nodeId);
    if (!node) return;

    inProgress.add(nodeId); // ← mark as in progress

    if (node.parent && map.has(node.parent)) {
      visit(node.parent);
    }

    inProgress.delete(nodeId); // ← done with this path
    visited.add(nodeId);
    sorted.push(node);
  }

  nodes.sort((a, b) => parseInt(a.nodeid) - parseInt(b.nodeid));
  for (const node of nodes) {
    visit(node.nodeid);
  }

  return sorted;
};

const AddItemToWoningTree = (dbItemToAdd: dbItem, woningTree: kamerItem) => {
  //console.log("A")
  let dbIcon = myTreeIcons.getTreeIcon2(dbItemToAdd.typeIcon, dbItemToAdd.type);
  let woningObject = woningTree;

  let dataForTree = {
    id: dbItemToAdd.nodeid,
    name: dbItemToAdd.label,
    children: [],
    icon: dbIcon,
    expanded: true,
    nodeid: dbItemToAdd.nodeid,
  };
  /*
  if (dbItemToAdd.typeIcon === "floor") {
    
    dataForTree = {
      id: dbItemToAdd.nodeid,
      name: dbItemToAdd.label,
      children: [],
      icon: dbIcon,
      expanded: true,
      nodeid: dbItemToAdd.nodeid
    };
    addExpanded(dbItemToAdd.nodeid)
  } else {
    dataForTree = {
      id: dbItemToAdd.nodeid,
      name: dbItemToAdd.label,
      children: [],
      icon: dbIcon,
      expanded: false,
      nodeid: dbItemToAdd.nodeid
    };
  }
*/

  if (woningObject.id === dbItemToAdd.parent) {
    let base: kamerItem = woningObject;
    base.children?.push(dataForTree);
  } else {
    const loopWoning = (nodes: kamerItem) =>
      nodes.children?.map((item) => {
        if (item.id === dbItemToAdd.parent) {
          item.children?.push(dataForTree);
        } else {
          loopWoning(item);
        }
      });
    loopWoning(woningObject);
  }

  return woningObject;
};

const ChangewoningTree = (
  moduleItem: dbItem,
  //parentId: string,
  currentTree: kamerItem // Replace `any` with actual tree type
) => {
  //const updatedDb: functions.dbItem[] = [...currentDb, moduleItem]; // immutable update
  // here we add the new item to our tree (buidling)
  const updatedTree = AddItemToWoningTree(moduleItem, currentTree);

  // const updatedDb: functions.dbItem[] = sortByDependencyAndNodeId(updatedDb1);

  return { updatedTree };
};

// This function generates the items for Woning Tree
export const buildWoningtreeFromDb = (woningDb: dbItem[]): kamerItem => {
  const t = getTranslations();
  // Static constants
  const rootWoningTreeIcon = (
    <Icon key="woning">
      <WoningIcon />
    </Icon>
  );
  
  const rootTreeItem: kamerItem = {
    id: "1",
    name: t.woning,
    key: "",
    nodeid: "1",
    children: [],
    expanded: true,
    icon: rootWoningTreeIcon,
  };

  // Sort items in the database - we don't want items to be added to a parent that comes later in the list
  const sortedw: dbItem[] = sortByDependencyAndNodeId(woningDb);
  let newTree = { ...rootTreeItem };

  newTree.children = [];
  // Here we add each item to the woningtree
  sortedw.forEach((dbitem: any) => {
    const { updatedTree } = ChangewoningTree(dbitem, newTree);
    newTree = updatedTree;
  });

  return newTree;
};

// This function returns the id of the selected room, used for parent / child
export const ChangeSelectedFloor = (
  woningSlectedNodeId: any,
  floorid: any,
  type: string,
  label: string
) => {
  let floor = woningSlectedNodeId;
  floor.id = floorid;
  floor.type = type;
  floor.label = label;

  return floor;
};
